// Phase 20 · Community V3 · Stateful RSVP button
import React, { useState } from "react";
import { Check, Calendar, X } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function EventRsvpButton({ event, viewer, onChange }) {
    const [busy, setBusy] = useState(false);
    const [rsvp, setRsvp] = useState(event.viewer_rsvp_status);

    const isDisabled = event.status === "ended" || event.status === "cancelled";

    const rsvpNow = async () => {
        if (!viewer) { toast.error("Login required"); return; }
        setBusy(true);
        try {
            const r = await fetch(`${API}/api/community/events/${event.id}/rsvp`, {
                method: "POST",
                credentials: "include",
            });
            if (r.ok) {
                setRsvp("registered");
                toast.success("You're in! We'll remind you 1h before.");
                onChange?.();
            } else if (r.status === 409) {
                toast.error("Event is full");
            } else if (r.status === 429) {
                toast.error("Too many RSVPs today, try tomorrow");
            } else {
                toast.error("RSVP failed");
            }
        } catch { toast.error("Network error"); }
        setBusy(false);
    };

    const cancel = async () => {
        setBusy(true);
        try {
            const r = await fetch(`${API}/api/community/events/${event.id}/rsvp`, {
                method: "DELETE",
                credentials: "include",
            });
            if (r.ok) {
                setRsvp("cancelled");
                toast.success("RSVP cancelled");
                onChange?.();
            } else toast.error("Cancel failed");
        } catch { toast.error("Network error"); }
        setBusy(false);
    };

    if (isDisabled) {
        return (
            <button
                type="button"
                disabled
                className="inline-flex items-center gap-2 px-4 py-2 bg-neutral-700/30 border border-neutral-700/50 text-neutral-500 rounded-xl text-sm font-semibold cursor-not-allowed"
                data-testid="event-rsvp-disabled"
            >
                {event.status === "ended" ? "Ended" : "Cancelled"}
            </button>
        );
    }

    if (rsvp === "registered") {
        return (
            <button
                type="button"
                onClick={cancel}
                disabled={busy}
                className="group inline-flex items-center gap-2 px-4 py-2 bg-[#CCCCCC]/10 border border-[#CCCCCC]/40 text-[#CCCCCC] hover:bg-[#FAFAFA]/10 hover:border-[#FAFAFA]/40 hover:text-[#FAFAFA] rounded-xl text-sm font-semibold transition-all"
                data-testid="event-rsvp-cancel"
            >
                <Check size={14} className="group-hover:hidden" />
                <X size={14} className="hidden group-hover:inline" />
                <span className="group-hover:hidden">Registered</span>
                <span className="hidden group-hover:inline">Cancel RSVP</span>
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={rsvpNow}
            disabled={busy || !viewer}
            className="inline-flex items-center gap-2 px-4 py-2 bg-white text-neutral-900 font-semibold rounded-xl text-sm hover:opacity-90 disabled:opacity-40 transition-all"
            data-testid="event-rsvp-register"
        >
            <Calendar size={14} /> RSVP
        </button>
    );
}
